import React, { FC } from 'react'

export const ContentPanel: FC = ({ children }) => {
  return <>{children}</>
}
ContentPanel.displayName = 'ListPage.ContentPanel'
